import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { MikrotikManagementPage } from '@/features/devices/mikrotik-management'

export const Route = createFileRoute('/_authenticated/devices/mikrotiks')({
  component: () => (
    <RequirePermission permission='mikrotik.read'>
      <MikrotikManagementPage />
    </RequirePermission>
  ),
})
